import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import RadioButton from "components/UI/radioButton/radioButton";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const Scale = ({
  questionId,
  questionType,
  options,
  submittedAnswer,
  responseAnswer,
  handleQuesAnswer,
  isFrom,
  event,
  variant,
  comment,
  linkageAnswer,
  question,
  hasAttachedDocument,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [commentBox, setCommentBox] = useState("");
  const [option, setOption] = useState({});
  const initialized = useRef(false);
  const [attachDocument, setAttachDocument] = useState(null);

  useEffect(() => {
    if (!initialized.current && submittedAnswer?.length > 0) {
      setSelectedOption(submittedAnswer[0]?.option || null);
      setCommentBox(submittedAnswer[0]?.comment || "");
      initialized.current = true;
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    }
  }, []);

  const handleChange = (type, value, extra = null) => {
    if (type === "option") {
      setSelectedOption(value);
      setOption(extra || {});
      handleQuesAnswer({
        obj: {
          option: value,
          comment: commentBox,
          supporting_document: attachDocument,
        },
        realQuestion: question,
      });
    } else if (type === "comment") {
      setCommentBox(value);
      handleQuesAnswer({
        obj: {
          option: selectedOption,
          comment: value,
          supporting_document: attachDocument,
        },
        realQuestion: question,
      });
    } else if (type === "document") {
      setAttachDocument(value);

      const obj = {
        option: type === "option" ? value : selectedOption,
        comment: type === "comment" ? value : commentBox,
        supporting_document:
          type === "document" && value === null ? value : attachDocument,
        document: type === "document" ? value : attachDocument,
        documentMetaData:
          type === "document"
            ? {
                ques_id: question?._id,
                name: value?.name,
                is_supporting_document: true,
                type: value?.type,
              }
            : null,
        weightage: 1,
      };
      handleQuesAnswer({ obj, realQuestion: question });
    }
  };

  const placeholderSize = {
    inputProps: {
      sx: { fontSize: "14px" },
    },
  };

  const labelSize = {
    style: { fontSize: "14px" },
  };

  return (
    <Box
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <FormControl
        component="fieldset"
        style={{ width: "100%", marginBottom: "10px" }}
      >
        <RadioGroup
          value={selectedOption || ""}
          onChange={(e) => handleChange("option", e.target.value, option)}
        >
          {options?.map((opt) => (
            <Box
              key={opt.option}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <FormControlLabel
                value={opt.option}
                control={<RadioButton color="primary" />}
                onClick={() => handleChange("option", opt.option, opt)}
                label={
                  <Typography variant={variant} style={{ fontSize: 14 }}>
                    {opt.option}
                  </Typography>
                }
                style={{ pointerEvents: event }}
              />
            </Box>
          ))}
        </RadioGroup>
      </FormControl>

      {comment && (
        <Box style={{ pointerEvents: event }}>
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}
      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChange}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default Scale;
